import { Reveal, Eyebrow } from "../Reveal";
import { IMAGES } from "../../lib/data";

const BuiltAround = () => (
  <section data-testid="built-around-section" className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-32">
    <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <Eyebrow>Built Around Your Business</Eyebrow>
        <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Downtime is not an option for a petroleum retail facility.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-mist md:text-lg">
          Gas stations and convenience stores operate every day, often around the clock.
          When something breaks, wears out or needs to be improved, the work has to fit around
          your operation — not the other way around.
        </p>
        <p className="mt-4 text-base leading-relaxed text-mist md:text-lg">
          Petroline Services provides practical commercial services designed around operational
          needs: responsive communication, organized execution and a focus on maintaining the
          condition, safety and appearance of your property.
        </p>
      </Reveal>

      <Reveal delay={0.15} className="relative">
        <div className="absolute -left-4 -top-4 h-full w-full border border-ember/40" aria-hidden="true" />
        <div className="absolute -inset-10 -z-10 rounded-full bg-ember/10 blur-3xl" aria-hidden="true" />
        <img
          src={IMAGES.maintenance.url}
          alt={IMAGES.maintenance.alt}
          loading="lazy"
          className="relative aspect-[4/3] w-full object-cover"
        />
        <div className="absolute bottom-0 left-0 bg-white px-5 py-3">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-ember">
            Commercial Facility Support
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);

export default BuiltAround;
